import React, { useEffect } from 'react';

function SnapScroll() {
    const sectionStyle = {
      height: '100vh',
      width: '110vw',
      overflowX: 'auto',
      scrollSnapType: 'y mandatory',
      position: 'fixed',
      top: 0,
      left: 0,
      border: '1px solid #ccc'
    };
  
    const itemStyle = {
      textAlign: 'center',
      scrollSnapAlign: 'center',
      flex: 'none',
      height: '100vh',
      lineHeight: '100vh',
      background: '#dadec1',
      margin: '2px',
      width: '100vw'
    };
  
    return (
      <section style={sectionStyle}>
        <div style={itemStyle}>Section 1</div>
        <div style={itemStyle}>Section 2</div>
        <div style={itemStyle}>Section 3</div>
        <div style={itemStyle}>Section 4</div>
        <div style={itemStyle}>Section 5</div>
      </section>
    );
  }

export default SnapScroll;